import { render } from "./CompetitionPodium.vue?vue&type=template&id=95462ff2&scoped=true"
import script from "./CompetitionPodium.vue?vue&type=script&lang=js"
export * from "./CompetitionPodium.vue?vue&type=script&lang=js"

import "./CompetitionPodium.vue?vue&type=style&index=0&id=95462ff2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95462ff2"]])

export default __exports__